import React from 'react';
import { useAlert } from '@uplift/ui-v2';
import { CollaborativeAgreementUnsigned } from '@uplift/api';
import { useSignCollaborativeAgreementMutation, useUserDisplayNameQuery } from '@uplift/queries';
import { useCurrentuser } from '@uplift/contexts';
import { AgreementSigningForm } from './AgreementSigningForm';
import { SignatureBlock, SignatureCard } from './SignatureCard';


export const SignAgreementCard = React.forwardRef<HTMLDivElement, {
  document: CollaborativeAgreementUnsigned;
  onSign: (agreementId: string) => void;
}>(({ document, onSign }, ref) => {
  const me = useCurrentuser();
  const { data: providerName } = useUserDisplayNameQuery(me.id, { suspense: true });
  const signMutation = useSignCollaborativeAgreementMutation(me.id);
  const alert = useAlert();

  return (
    <SignatureCard ref={ref} title="Sign this agreement">
      <AgreementSigningForm
        consentLabel="By checking this, I agree this constitutes my legal electronic signature on this collaborative practice agreement."
        onSubmit={async () => {
          const signedAgreementId = await signMutation.mutateAsync({
            agreementTemplateId: document.agreementTemplateId,
            collaborativeMatchId: document.collaborativeMatchId,
          });

          onSign(signedAgreementId);
          alert.success('Successfully signed the agreement');
        }}
      >
        <SignatureBlock name={providerName.fullLegalName} />
      </AgreementSigningForm>
    </SignatureCard>
  );
});
